type ProviderKey = "stripe" | "paddle" | "lemonsqueezy" | "dodopayments";

interface BrandIcon {
	title: string;
	path: string;
	/** When set, render the glyph inside a rounded-square brand badge. */
	badge?: string;
	/** Glyph color inside the badge (defaults to white). */
	mark?: string;
}

// Official simple-icons SVG path data (24x24 viewBox, single-color).
// Polar and Whop have no entry in simple-icons (confirmed 404 across all slug
// variants), so those providers render no logo and rely on the text label.
const PROVIDER_ICONS: Record<ProviderKey, BrandIcon> = {
	stripe: {
		title: "Stripe",
		badge: "#635BFF",
		mark: "#ffffff",
		path: "M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z",
	},
	paddle: {
		title: "Paddle",
		path: "M2.363 7.904v.849a3.95 3.95 0 0 1 3.65 2.425c.198.476.3.987.299 1.502h.791c0-1.04.416-2.037 1.157-2.772a3.962 3.962 0 0 1 2.792-1.149V7.91a3.959 3.959 0 0 1-3.65-2.425 3.893 3.893 0 0 1-.299-1.502h-.791c0 1.04-.416 2.037-1.157 2.772a3.96 3.96 0 0 1-2.792 1.149M13.105 2.51H6.312V0h6.793c4.772 0 8.532 3.735 8.532 8.314 0 4.58-3.76 8.314-8.532 8.314H9.156V24H6.312v-9.882h6.793c3.319 0 5.688-2.352 5.688-5.804 0-3.451-2.37-5.804-5.688-5.804",
	},
	lemonsqueezy: {
		title: "Lemon Squeezy",
		path: "m7.4916 10.835 2.3748-6.5114a3.1497 3.1497 0 0 0-.065-2.3418C9.0315.183 6.9427-.398 5.2928.265 3.643.929 2.71 2.4348 3.512 4.3046l2.8197 6.5615c.219.509.97.489 1.16-.03m1.6798 1.0969 6.5334-2.7758c2.1699-.9219 2.7218-3.6907 1.022-5.2905l-.068-.063c-1.6669-1.5469-4.4217-1.002-5.3706 1.0359L8.3566 11.135c-.234.503.295 1.0199.8159.7979m.373.87 6.6454-2.5119c2.2078-.8349 4.6206.745 4.5886 3.0398l-.002.09c-.048 2.2358-2.3938 3.7376-4.5536 2.9467l-6.6724-2.4418a.595.595 0 0 1-.006-1.1229m-.386 1.9269 6.4375 2.9767a3.2997 3.2997 0 0 1 1.6658 1.6989c.769 1.7998-.283 3.6396-1.9328 4.3016-1.6499.662-3.4097.235-4.2097-1.6359l-2.8027-6.5694c-.217-.509.328-1.009.8419-.772",
	},
	dodopayments: {
		title: "Dodo Payments",
		path: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0M8.21 5.414c2.44-.162 4.62 1.036 5.858 2.98.484.941 5.714-.545 7.354 3.047l.004.002c.446 1.184-.004 3.374-.703 4.764-.074.147-.258.292-.338.068-.938-2.441-4.856-1.943-5.016-1.935h-.01c-.752.085-1.809.073-2.597.2-.327.044-.407.382-.47.648-.345 1.467.667 3.628 1.552 5.212h-5.73c-1.98-3.1-6.057-8.862-3.64-12.68l.005-.011v-.002l.001-.002V7.7l-.001-.002-.006-.011v-.002l-.002-.002a.3.3 0 0 0-.116-.041s-.739-.177-.753-.198c.342-.45.892-.748 1.332-1.005.084-.047.14-.068.154-.084v-.002l.002-.002v-.002l.002-.002v-.002l-.002-.002V6.34l-.002-.002c-.016-.016-.075-.037-.184-.078-.065-.024-.053-.02-.097-.04l-.59-.26c.979-.615 2.493-.568 2.933-.392q.537-.119 1.06-.154m1.427 1.797a3 3 0 0 0-.604.078c-.614.136-1.154.497-1.447 1.05-.906 1.631-.09 3.73 1.435 4.659l.006.006c1.048.714 3.768.708 4.883.713.227-.016.454-.028.59-.143.157-.128.154-.375.135-.57-.035-.354-.07-.701-.045-1.055a4.4 4.4 0 0 1 .51-1.687l-.002-.002c.235-.4.382-.734-.205-.875-.314-.064-.64-.051-.954-.14-.681-.146-1.126-.619-1.646-1.073-.262-.22-.607-.413-.895-.559a3.6 3.6 0 0 0-1.761-.402m.644 1.613a1 1 0 0 1 .28.037h.007c1.253.394.706 2.22-.568 1.858-.52-.16-.815-.74-.629-1.246a.99.99 0 0 1 .91-.649",
	},
};

const PROVIDER_LABELS: Record<string, string> = {
	stripe: "Stripe",
	paddle: "Paddle",
	lemonsqueezy: "Lemon Squeezy",
	dodopayments: "Dodo Payments",
	polar: "Polar",
	whop: "Whop",
	creem: "Creem",
	revenuecat: "RevenueCat",
};

function capitalize(value: string) {
	return value.charAt(0).toUpperCase() + value.slice(1);
}

function normalizeKey(provider: string) {
	return provider.toLowerCase().replace(/[\s_-]+/g, "");
}

function normalizeProvider(provider: string): ProviderKey | null {
	const key = normalizeKey(provider);
	if (key === "lemon" || key === "lemonsqueezy" || key === "ls") {
		return "lemonsqueezy";
	}
	if (key === "dodo" || key === "dodopayments") {
		return "dodopayments";
	}
	if (key in PROVIDER_ICONS) {
		return key as ProviderKey;
	}
	return null;
}

/** Proper-cased display name for a provider, e.g. "Lemon Squeezy". */
export function providerDisplayName(provider: string): string {
	return PROVIDER_LABELS[normalizeKey(provider)] ?? capitalize(provider);
}

export interface ProviderLogoProps {
	provider: string | null | undefined;
	className?: string;
}

/** Renders the provider's brand mark, or null when no logo is available. */
export function ProviderLogo({ provider, className }: ProviderLogoProps) {
	if (!provider) {
		return null;
	}

	const key = normalizeProvider(provider);
	if (!key) {
		return null;
	}

	const icon = PROVIDER_ICONS[key];

	if (icon.badge) {
		return (
			<svg
				role="img"
				aria-label={icon.title}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
			>
				<title>{icon.title}</title>
				<rect width="24" height="24" rx="5.5" fill={icon.badge} />
				<g
					transform="translate(5 4.8) scale(0.6)"
					fill={icon.mark ?? "#ffffff"}
				>
					<path d={icon.path} />
				</g>
			</svg>
		);
	}

	return (
		<svg
			role="img"
			aria-label={icon.title}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			fill="currentColor"
		>
			<title>{icon.title}</title>
			<path d={icon.path} />
		</svg>
	);
}
